import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import HeaderNavigation from "components/PeopleCraft/HeaderNavigation";
import { transformText } from "utils/Utils";
import { AuthContext } from "../../../context/AuthContext";

import "./styles.scss";

const INTEGRATION_OPTIONS = [
  {
    name: "Feedz",
    description: "Configurar integrações",
  },
];

const Integration = () => {
  const { loginData } = useContext(AuthContext);
  const primaryColor = loginData.primaryColor;

  return (
    <div className="integrations">
      <HeaderNavigation title="Integrações" />
      <h4 className="header-title title">Integrações</h4>
      <span className="subtitle">
        Ative conexões com plataformas parceiras e habilite funcionalidades adicionais. Clique em
        uma integração para configurar.
      </span>
      <div style={{ display: "flex", gap: 10 }}>
        {INTEGRATION_OPTIONS.map(({ name, description }, index) => (
          <NavLink
            className="cockpit-card"
            key={index}
            to={`/configuracao/integracoes/${transformText(name)}/`}
          >
            <div className="cockpit-card-header" style={{ backgroundColor: primaryColor }}>
              <h3 style={{ color: "#fff" }}>{name}</h3>
            </div>
            <div className="cockpit-card-content">{description}</div>
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default Integration;
